import React, {useContext} from "react";
import PropTypes from "prop-types";
import BuyAShareDialog from "./BuyAShareDialog";
import {CurrencyContext} from "../../../store/providers/CurrencyProvider";
import {useMarketplaceShareInfo} from "../../../store/providers/MarketplaceShareInfoProvider";

const BuyAShareDialogWrapper = ({isOpen, onClose}) => {
    const {currency} = useContext(CurrencyContext)?.[0];
    const {shareData} = useMarketplaceShareInfo();

    return (
        <BuyAShareDialog
            isOpen={isOpen}
            onClose={onClose}
            averagePrice={shareData?.medianPrice?.original_price}
            averagePriceForDirect={shareData?.directSalesPrice}
            convertedAveragePrice={shareData?.medianPrice?.converted_price}
            currency={currency}
        />
    );
};

BuyAShareDialogWrapper.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func
};


export default BuyAShareDialogWrapper;
